import { create } from "zustand";
import { getFromLocal, saveToLocal } from "src/util/cache.service";
import { LOCAL_KEYS } from "src/util/util.constant";

type DistributorId = number | string | null;

interface SelectDistributorState {
  selectedDistributor: DistributorId;
  setSelectedDistributor: (distributorId: DistributorId) => void;
  clearSelectedDistributor: () => void;
  reset: () => void;
}

const getInitialSelectedDistributor = (): DistributorId =>
  getFromLocal<DistributorId>(LOCAL_KEYS.SELECTED_DISTRIBUTOR, false, true) ||
  null;

export const useSelectDistributor = create<SelectDistributorState>((set) => ({
  selectedDistributor: getInitialSelectedDistributor(),

  setSelectedDistributor: (distributorId) => {
    set({ selectedDistributor: distributorId });
    saveToLocal(LOCAL_KEYS.SELECTED_DISTRIBUTOR, distributorId, false, true);
  },

  clearSelectedDistributor: () => {
    set({ selectedDistributor: null });
    saveToLocal(LOCAL_KEYS.SELECTED_DISTRIBUTOR, null, false, true);
  },

  reset: () => set({ selectedDistributor: getInitialSelectedDistributor() }),
}));
